'use client';

import { type ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
    querySelector?: string;
    children: ReactNode;
};

export default function Portal({ querySelector, children }: PortalProps) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        // A trick to make this component server renderable.
        // typeof window === 'undefined' on the server
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) return null;

    const root: HTMLElement | null = document.querySelector<any>(querySelector) ?? null;
    if (root === null)
        throw new Error(`Portal root element not found with query "${querySelector}"`);

    return createPortal(children, root);
}
